import { render, staticRenderFns } from "./Exhibition.vue?vue&type=template&id=2d7841c2"
import script from "./Exhibition.vue?vue&type=script&lang=ts"
export * from "./Exhibition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports